import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditorView } from "prosemirror-view";

import { billingUpgradeIconDef } from "~/billing/utils";
import type { TooltipProps } from "~/lib/utils";
import {
	type AssignableDropdownItemType,
	disableOnLinkedCopy,
	type DisableOnLinkedCopyArgs,
} from "~/notes/AssignableDropdown";

import styles from "~/notes/css/assignableDropdown.module.css";

export function getActionItemKebabMenuEntry({
	integrationActive,
	hasAccessToIntegration,
	showFeatureModal,
	showUserOrAccountIntegrationInitialization,
	integrationKey,
	displayName,
	logo,
	hasAccessToOriginalNote = true,
	isGuest,
	actionItemLinkedToIntegration,
	openCreateLinkModal,
	openDeleteLinkModal,
	disabled,
	tooltip,
	...rest
}: {
	integrationActive: boolean;
	hasAccessToIntegration: boolean;
	showFeatureModal: () => void;
	showUserOrAccountIntegrationInitialization: () => void;
	logo: React.ReactNode;
	integrationKey: string;
	displayName: string;
	view: EditorView;
	blockKey: string;
	isGuest?: boolean;
	actionItemLinkedToIntegration: boolean;
	openCreateLinkModal: () => void;
	openDeleteLinkModal: () => void;
	disabled: boolean;
	tooltip?: TooltipProps;
} & DisableOnLinkedCopyArgs): NonNullable<AssignableDropdownItemType> {
	return {
		id: `kebab-${integrationKey}`,
		disabled: !hasAccessToOriginalNote || isGuest || disabled,
		action: (): boolean => {
			if (actionItemLinkedToIntegration) {
				openDeleteLinkModal();
				return true;
			}
			if (!integrationActive) {
				if (!hasAccessToIntegration) {
					showFeatureModal();
					return true;
				}
				showUserOrAccountIntegrationInitialization();
				return true;
			}

			if (!hasAccessToIntegration) {
				showFeatureModal();
				return true;
			}

			openCreateLinkModal();

			return false;
		},
		left: logo,
		right: (() => {
			if (actionItemLinkedToIntegration) {
				return (
					<div contentEditable={false} className={styles.menuItemWithCrown}>
						<span>Unlink from {displayName}…</span>
					</div>
				);
			}
			return (
				<div contentEditable={false} className={styles.menuItemWithCrown}>
					<span>Link to {displayName}…</span>
					{!hasAccessToIntegration && <FontAwesomeIcon icon={billingUpgradeIconDef} />}
				</div>
			);
		})(),
		...disableOnLinkedCopy({ ...rest, hasAccessToOriginalNote }),
		toolTip: tooltip,
	};
}
